import { getFormattedMoney } from "//ringconn.com/cdn/shop/t/172/assets/theme.js?v=175434393328040865581767172956";
var CareSin = class extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.clickCount = 0; // 添加点击计数器
  }

  connectedCallback() {
    // this._loadRecommendations();
  }

  init() {
    this.careVariants = this.querySelectorAll(".care-variant");
    if (this.careVariants) {
      this.careVariants.forEach((careVariant) => {
        careVariant.addEventListener("click", () => {
          this.handleVariantClick(careVariant);
        });
      });
    }
    this.error = this.querySelector(".care-variant-error");
    this.input = this.querySelector("input");
    this.care_learn_more = this.querySelector(".care_learn_more");
    this.care_drawer = document.querySelector("x-drawer.care_drawer"); // 修改为获取 x-drawer
  }
  open() {
    if (!this.care_drawer) {
      console.error("Trade drawer not found");
      return;
    }
    this.care_drawer.querySelector(".care_button").style.display = "block";
    // console.log(this.care_drawer, "care_drawer");
    const overlay = this.care_drawer.shadowRoot.querySelector('div[part="overlay"]');
    if (overlay) {
      overlay.style.display = "block";
    }
    this.care_drawer.show();
    this.care_drawer.setAttribute("open", "");

    // 设置垂直居中
    const height = this.care_drawer.offsetHeight;
    this.care_drawer.style.top = `calc(50vh - ${height * 0.5}px)`;
  }
  // 处理 Learn More 点击事件
  handleLearnMoreClick() {
    this.clickCount++;

    if (this.clickCount === 1) {
      // 第一次点击，打开最后一个 drawer
      this.open();
    } else {
      // 后续点击，显示前两个 drawer
      this.open();
      // 重置点击计数
      this.clickCount = 0;
    }
  }
  handleisButtonClick(event) {
    this.careVariants.forEach((careVariant) => {
      careVariant.removeAttribute("careActive");
    });
    // console.log(event.currentTarget, "this.careVariants");
    event?.setAttribute("careActive", true);

    if (this.error) {
      this.error.style.display = "none";
    }

    if (this.input) {
      this.input.value = event?.dataset.id || "";
    }

    const price = Number(event.dataset?.price || 0);
    const initialPriceText = document.querySelector(".rating-with-text sale-price");
    const initialPrice = initialPriceText.dataset.price;
    // console.log(initialPrice, "initialPrice");
    const tradeIn = document.querySelector('trade-in input[name="tradein-device"]');
    const newPrice = price + Number(initialPrice) - Number(tradeIn?.dataset?.devicePrice || 0);
    // console.log(newPrice, "newPrice");
    const salePrice = document.querySelector(" .product-info__buy-buttons .buy-bottons_price price-list sale-price");
    salePrice.lastChild.replaceWith(document.createRange().createContextualFragment(getFormattedMoney(newPrice)));
    this.care_drawer.removeAttribute("open");
    document.dispatchEvent(new CustomEvent("care:change"));
  }
  handleVariantClick(event) {
    // console.log(event, "event handleVariantClick");
    const currentDataId = event.dataset.id;
    const previousActive = this.querySelector('.care-variant[careActive="true"]');
    const closeButton = this.care_drawer.querySelector(".care_button");
    closeButton.style.display = "block";
    if (currentDataId && currentDataId !== previousActive?.dataset.id) {
      this.open();
    }
    if (currentDataId) {
      if (closeButton) {
        closeButton.addEventListener("click", () => {
          this.handleisButtonClick(event);
          document.dispatchEvent(new CustomEvent("care:change"));
        });
      }
    } else {
      this.handleisButtonClick(event);
      document.dispatchEvent(new CustomEvent("care:change"));
    }
  }
};

if (!window.customElements.get("care-sin")) {
  window.customElements.define("care-sin", CareSin);
}
